export default __webpack_public_path__ + "static/media/BrainlabNowW05-Bold.f1254a9b.woff2";